import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {ChartComponent} from "ng-apexcharts";
import {ChartOptions, ChartOptionsArea} from "../mis-education/mis-education.component";
import {Observable, of, Subject} from "rxjs";
import {Centre} from "../../../interfaces/Centres";
import {CentreService} from "../../../services/centre.service";
import {ChildService} from "../../child/child.service";
import {MembershipService} from "../../../modules/membership/membership.service";
import {Inquiry8080ServiceService} from "../../../modules/inquiry-8080/inquiry-8080-service.service";
import {VolunteerService} from "../../volunteers/volunteer.service";
import {HospitalService} from "../../../services/hospital.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MealMateService} from "../../../modules/meal-mate/meal-mate.service";
import {collection, getCountFromServer, getFirestore, query} from "firebase/firestore";
import {MatTableDataSource} from "@angular/material/table";
import {takeUntil} from "rxjs/internal/operators/takeUntil";
import {FullChild} from "../../../interfaces/FullChild";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {FormControl} from "@angular/forms";
import {Hospitals} from "../../../interfaces/Hospitals";

@Component({
  selector: 'app-mis-oprations',
  templateUrl: './mis-oprations.component.html',
  styleUrls: ['./mis-oprations.component.scss']
})
export class MisOprationsComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  @ViewChild("areaChart") areaChart!: ChartComponent;
  @ViewChild("barChart") barChart!: ChartComponent;
  @ViewChild(MatSort) sort!: MatSort;
  mStartDate?: Date | null
  mEndDate?: Date | null
  isSeniorTeacher = true; // or false for testing
  selectedCentre = '';
  centres$: Observable<Centre[]>;
  allowedCentres$ :Observable<Centre[]>;
  startDate: Date = new Date('2023-04-01')
  endDate: Date = new Date('2023-06-30')
  dataTableLoaded = false;
  totalMemberShip :any;
  total8080Count :any;
  totalVolunteersCount :any;
  totalMswCount :any;
  totalHospitalCount :any;
  upComingEvents :any;
  totalMealmate :any;
  dataSource!: MatTableDataSource<Centre>;

  userData: any
  private _destroyed$ = new Subject<void>()
  mCentres: Centre[] = []
  allCentres: any[] = [];
  extraRowAdded = false
  mChildren: FullChild[] = []
  mAllChildren: FullChild[] = []
  mAdmissionChartCentres: string[] = []
  mAdmissionChartUniqueCount: number[] = []
  mAdmissionChartFollowUpCount: number[] = []
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) matSort!: MatSort;
  displayedColumns: String[] = ['sr','centername', 'totalUnits', 'occupiedUnits', 'availableUnits', 'centrePercentage', 'occupancyPercentage'];
  //*********** For Occupancy card******************
  totalUnits = 0
  totalOccupiedUnits = 0
  totalAvailableUnits = 0
  centrePercentage = 0
  totalRanking=0
//***********************
//************CHILD DATA************
  totalRegisteredChildren = 0
  totalRegisteredGirls = 0
  totalRegisteredBoys = 0
  freshBoys = 0
  freshGirls = 0
  followupBoys = 0
  followupGirls = 0
//*********************************
  ageArray: number[] = []
  mFollowUpAgeArray: number[] = []
  a = 0
  af = 0
  b = 0
  bf = 0
  c1 = 0
  cf = 0
  d = 0
  df = 0
  e = 0
  ef = 0
  HospitalLables: any[] = []
  HospitalCount: any[] = []
  mFollowUpHospitalCount: any[] = []
  hosptalLables$ = of(this.HospitalLables)
  hospitalCount$ = of(this.HospitalCount)
  mFollowUpHospitalCount$ = of(this.mFollowUpHospitalCount)
  hData: any[] = []
  sortBy: "byDate" | 'byYear' | 'byCentre' = 'byCentre'
  selectCentre = new FormControl('All')
  sortBySelect = new FormControl(this.sortBy)
  loading = false
  currentCentreName = 'All Centres'
  selectedCentreOption: any;
  totalAdmissionCount = 0;
  showAdmissionChart = false;
  hospitals$!: Observable<Hospitals[]>



  constructor(private centerService  : CentreService,
              private membershipService : MembershipService,
              private inquiry8080ServiceService : Inquiry8080ServiceService,
              private volunteersService : VolunteerService,
              private hospitalService : HospitalService,
              private  childService :ChildService,
              private mealMateService : MealMateService,
              private firestore : AngularFirestore) {
    this.dataSource = new MatTableDataSource(this.allCentres);

    this.centres$ = this.centerService.getAllCentres()
    this.allowedCentres$ = this.centerService.getAllCentres();


  }

  ngOnInit(){
    this.loadMisEduDashboardData();
    this.initAllCentresData('All')
    this.membershipService.getMembershipCountFromServer().then(count => this.totalMemberShip = count);
    this.inquiry8080ServiceService.get8080CountFromServer().then(count => this.total8080Count = count);
    this.volunteersService.getVolunteersCountFromServer().then(count => this.totalVolunteersCount = count);
    this.totalHospitalCount = this.hospitalService.getHospitalCount().pipe(takeUntil(this._destroyed$)).subscribe(count => this.totalHospitalCount = count);
    this.totalMswCount = this.hospitalService.getHospitalMSWCount().pipe(takeUntil(this._destroyed$)).subscribe(count => this.totalMswCount = count);
    this.mealMateService.getMealmateCountFromServer().then(count => this.totalMealmate = count);
    getCountFromServer(query(collection(getFirestore(), 'events'))).then(snap => this.upComingEvents = snap.data().count);
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
  //* On ngInit to get all centres data
  lastRow?: Centre;
  private async initAllCentresData(centreCode: string) {
    if (centreCode === 'All') {
      // At startup when centreCode == "All"
      this.centerService.getAllCentres().pipe(takeUntil(this._destroyed$))
        .subscribe(centres => {
          this.allCentres = centres;
          this.mCentres = []
          // console.log('CENTRE LIST TABLE', centres);
          this.allCentres = centres.filter(x=>x.centreCode !='ALBandra')
          this.totalUnits = 0;
          this.totalAvailableUnits = 0;
          this.totalOccupiedUnits = 0;
          this.centrePercentage = 0
          this.allCentres.forEach(c => {
            this.totalUnits += +c.totalUnits!;
            this.totalAvailableUnits += +c.availableUnits!;
            this.totalOccupiedUnits += +c.occupiedUnits!;
            c.centrePercentage = parseFloat(this.getPercentage(c))
            c.totalRanking= parseFloat((c.totalRanking).toFixed(0))
            if(!c.totalRanking==null)    this.getTotalRanking(c.centreCode).then(r=>{
              if(!c.totalRanking) {
                // @ts-ignore
                c.totalRanking  =parseFloat(r).toFixed(0)      }
              else {
                c.totalRanking= parseFloat((c.totalRanking).toFixed(0))
              }
            })

            // console.log(parseFloat(this.getPercentage(c)))
          });

          let totalName = 'Total';
          // console.log(this.allCentres)
          this.allCentres.sort((a, b) => (a.centreName || '').localeCompare(b.centreName || ''));
          this.dataSource =  new MatTableDataSource(this.allCentres);
          this.dataTableLoaded = true;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.addextraRowtoOccupancyTable(this.totalUnits, this.totalAvailableUnits, this.totalOccupiedUnits, totalName);

        });
    } else {
      console.log('Into getAllCentresData with centreCode ==', centreCode);
      this.mCentres = this.allCentres.filter(c => c.centreCode === centreCode);
      console.log('CENTRE LIST TABLE', this.mCentres);

      this.totalUnits = 0;
      this.totalAvailableUnits = 0;
      this.totalOccupiedUnits = 0;
      this.centrePercentage = 0
      this.totalRanking = 0
      this.mCentres.forEach(c => {
        this.totalUnits += +c.totalUnits!;
        this.totalAvailableUnits += +c.availableUnits!;
        this.totalOccupiedUnits += +c.occupiedUnits!;
        this.centrePercentage = parseFloat(this.getPercentage(c))
// this.totalRanking   =this.getTotalRanking(c.centreCode)
        this.getTotalRanking(c.centreCode).then(r=>{
          if(!c.totalRanking) {
            c.totalRanking  =r               }
          else {
            c.totalRanking= <Number>(c.totalRanking).toFixed(2)
          }
        })
      });
      let totalName = 'Total';
      this.addextraRowtoOccupancyTable(this.totalUnits, this.totalAvailableUnits, this.totalOccupiedUnits, totalName);
      this.dataSource = new MatTableDataSource(this.mCentres);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort

    }
  }
  loadMisEduDashboardData(){
  }
  getPercentage(element: Centre | any) {

    try {
      if (element.totalUnits != null && element.occupiedUnits != null) {
        let total = element.totalUnits
        let available = element.occupiedUnits
        let percentage = available / total * 100
        // console.log(` ${total} ${available} ${percentage}`)
        return percentage.toFixed(2)
      }
    } catch (e) {
      console.log(e)
    }
    return 'error'
  }
  async getTotalRanking(centreCode: string): Promise<number | undefined> {
    console.log('into total ranking');


    const rankingData = await this.firestore.collection(this.env.centreRankings).doc(centreCode).get().toPromise();
    // @ts-ignore
    const ranking = rankingData.data();
    const currentDate =new Date()
    const lastDate = getDateBeforeMonth(currentDate)
    console.log(ranking)
// @ts-ignore
    const lastMonthRanking= ranking.rankings.filter((x:RankingData)=>x.startDate.toDate()<=currentDate && x.endDate.toDate())
    // @ts-ignore
    const averageOccupancy = this.calculateAverageOccupancy(lastMonthRanking);
    console.log(`Average occupancy for center ${centreCode}: ${averageOccupancy}`);
    // this.mFirestore.collection('ALCentres').doc(centreCode).update({'totalRanking':averageOccupancy}).then(()=>{
    //     console.log('updated ranking in ',centreCode)
    // })
    return averageOccupancy;

  }
  resetDate() {
    this.mStartDate = null
    this.mEndDate = null
    this.selectedCentreOption = 'All'
  }
  private addextraRowtoOccupancyTable(totalUnits: number, totalAvailableUnits: number, totalOccupiedUnits: number, totalCentres: string) {
    totalUnits = 0
    totalAvailableUnits = 0
    totalOccupiedUnits = 0
    // console.log(this.mCentres)
    this.allCentres.forEach(c => {
      totalUnits = totalUnits += c.totalUnits!
      totalAvailableUnits = totalAvailableUnits += c.availableUnits!
      totalOccupiedUnits = totalOccupiedUnits += c.occupiedUnits!

    })
    let c = {
      centreName: totalCentres,
      availableUnits: totalAvailableUnits,
      occupiedUnits: totalOccupiedUnits,
      totalUnits: totalUnits
    }
    this.lastRow = c as unknown as Centre
    // if(!this.extraRowAdded)     this.mCentres.push(this.lastRow)
    this.extraRowAdded = true

  }


}

function getDateBeforeMonth(date:Date) {
  // Create a copy of the date object to avoid modifying the original
  const newDate = new Date(date.getTime());

  // Set the date to the first day of the current month
  newDate.setDate(1);

  // Subtract one day to get the date before the current month
  newDate.setDate(newDate.getDate() - 1);

  // Return the modified date object
  return newDate;
}
